module.exports = __webpack_public_path__ + "static/media/DSC_0195.47df5190.jpg";